export default __webpack_public_path__ + "static/media/service-02.1e39262c.jpg";